import React, { useState, useEffect } from 'react';
import { FaUserShield, FaLock } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const AdminLogin: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('admin-auth') === 'true') {
      navigate('/admin');
    }
  }, [navigate]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    // تحقق وهمي (سيتم ربط backend لاحقاً)
    setTimeout(() => {
      setLoading(false);
      if (email === 'admin@mecca.com' && password === 'admin123') {
        // حفظ حالة الدخول (سيتم استبدالها بـ JWT لاحقاً)
        localStorage.setItem('admin-auth', 'true');
        navigate('/admin');
      } else {
        setError('البريد الإلكتروني أو كلمة المرور غير صحيحة');
      }
    }, 1000);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 font-cairo">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md mx-4">
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-2">
            <FaUserShield className="text-blue-700 w-8 h-8" />
          </div>
          <h2 className="text-2xl font-bold text-blue-900 mb-1">تسجيل دخول الإدارة</h2>
          <p className="text-gray-500 text-sm">لوحة تحكم مكة البركة للمقاولات</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block mb-1 font-semibold text-gray-700">البريد الإلكتروني</label>
            <input
              type="email"
              className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoFocus
              dir="ltr"
            />
          </div>
          <div>
            <label className="block mb-1 font-semibold text-gray-700">كلمة المرور</label>
            <input
              type="password"
              className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              dir="ltr"
            />
          </div>
          {error && <div className="text-red-600 text-sm text-center">{error}</div>}
          <button
            type="submit"
            className="w-full bg-gradient-to-r from-blue-700 to-blue-500 text-white font-bold py-2 rounded-lg shadow hover:scale-105 transition-all flex items-center justify-center gap-2"
            disabled={loading}
          >
            <FaLock />
            {loading ? 'جاري الدخول...' : 'دخول الإدارة'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin; 